<template>
  <div class="p_custom_content">
    <div class="topOperation">
      <div class="top-left">
        <div>
          <ShowNavHead />
        </div>
        <div class="screenInputs">
          <div class="screenInput">
            <div class="flname">客户名称</div>
            <el-input v-model="listQuery.custname" placeholder="请输入客户名称或简称" clearable @keyup.enter.native="searchHandle"></el-input>
          </div>
          <div class="screenInput">
            <div class="flname">所属集团名称</div>
            <el-input v-model="listQuery.groupname" clearable></el-input>
          </div>
          <div class="screenInput">
            <el-tooltip class="scr_icon" effect="dark" content="更多检索项" placement="top-start">
              <i class="i_txt" @click="dropDownScreen">更多<i class="el-icon-caret-bottom"></i></i>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="top-right">
        <el-button v-if="showDropScreen==-1" type="success" size="small" @click="searchHandle" :style="'margin-right:' +((tableData.length>0)?'8px':'16px')">搜索</el-button>
        <el-button v-if="checkPermission(['customList_add'],permissionLists)" type="primary" size="small" @click="addHandle" :style="'margin-right:' +((tableData.length>0)?'8px':'16px')">新增客户</el-button>
        <el-button v-if="(tableData.length>0)&&checkPermission(['customList_export'],permissionLists)" type="warning" plain size="small" @click="exportHandle" :loading="btnLoading" :style="'margin-right:' +(tableData == []?'0':'16px')">导出</el-button>
      </div>
    </div>
    <!-- 筛选下拉框 -->
    <div class="r_dropDownScreen" v-show="showDropScreen==1">
      <div class="cus_drop_box">
        <el-form :inline="true" :model="listQuery" class="cus_drop_form" label-width="100px">
          <el-form-item label="业务员部门:">
            <el-cascader ref="cascaderArrDep" v-model="listQuery.strBusidepList" :props="props" clearable filterable :options="departmentList" @change="searchDepHandle($event)"></el-cascader>
          </el-form-item>
          <el-form-item label="业务员:">
            <el-select v-model="listQuery.username" filterable clearable placeholder="请输入搜索或选择业务员">
              <el-option v-for="(item,index) in salesmanSearchList" :key="index" :label="item.Username" :value="item.Userid">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户等级:">
            <el-select v-model="listQuery.strCustlevel" clearable>
              <el-option v-for="(item,index) in levelList" :key="'a'+index" :label="item.StrCustprolevelName" :value="item.Custprolevelid">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户类别:">
            <el-select v-model="listQuery.strCustType" clearable @change="searchCustHandle" placeholder="请输入搜索或选择客户类别" filterable>
              <el-option v-for="(item,index) in industryList" :key="'b'+index" :label="item.StrCustindustName" :value="item.Custindustid">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户行业:">
            <el-select v-model="listQuery.strCustindust" clearable filterable placeholder="请输入搜索或选择客户行业">
              <el-option v-for="(item,index) in industryNameList" :key="'c'+index" :label="item.StrCustindustName" :value="item.Custindustid">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所在地区:">
            <el-cascader ref="regAddress" :props="propsAddress" v-model="regAddress" placeholder="" :options="areaList" clearable filterable @change="changeAddress" @clear="clearAddress"></el-cascader>
          </el-form-item>
        </el-form>
      </div>
      <div class="drop-footer">
        <el-button size="small" plain @click="resetHandle">清空</el-button>
        <el-button size="small" type="success" @click="searchHandle">搜索</el-button>
        <el-button size="small" plain @click="closeSearchHandle">关闭</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>客户</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/customList' }">客户列表</el-breadcrumb-item>
          <el-breadcrumb-item>立项客户</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="p_cus_table" v-if="checkPermission(['customList_page_list'],permissionLists)">
        <el-table v-loading="tableLoading" :highlight-current-row="true" :max-height="tableHeight-100" :data="tableData" style="width:100%" stripe>
          <el-table-column align="center" label="客户ID" fixed width="60px">
            <template slot-scope="{row}">
              <span>{{row.Custid}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="客户简称" fixed min-width="150px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.StrCustShortName}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="客户名称" min-width="280px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.StrCustName}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="所属集团名称" min-width="130px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.StrGroupName}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="省份" min-width="100px">
            <template slot-scope="{row}">
              <span>{{row.StrProvince}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="城市" min-width="100px">
            <template slot-scope="{row}">
              <span>{{row.StrCity}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="地区" prop="StrArea" min-width="100px">
          </el-table-column>
          <el-table-column align="center" label="业务员部门/业务员" min-width="200px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{ row.StrBusidep}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="客户等级">
            <template slot-scope="{row}">
              <span>{{row.StrCustprolevelName}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="客户类别" min-width="100px">
            <template slot-scope="{row}">
              <span>{{row.strCustTypeName}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="客户行业" min-width="200px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.strCustindustName}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="创建时间" min-width="150px">
            <template slot-scope="{row}">
              <span>{{row.DtInsertDate.replace('T',' ')}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" fixed="right" :width="checkPermission(['customList_edit'],permissionLists)||checkPermission(['customList_dlt'],permissionLists)?'230px':'100px'">
            <template slot-scope="{row}">
              <el-button v-if="checkPermission(['customList_edit'],permissionLists)" type="primary" size="mini" plain @click="editHandle(row)">编辑</el-button>
              <el-button v-if="checkPermission(['customList_dlt'],permissionLists)" type="danger" size="mini" plain @click="deleteHandle(row)">删除</el-button>
              <el-button type="success" size="mini" plain @click="dtlHandle(row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination @current-change="changeBPage" :current-page.sync="listQuery.currpage" :page-size="listQuery.perpage" @size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100]" layout="total,sizes,prev,pager,next,jumper" :total="total"></el-pagination>
        </div>
      </div>
    </div>

    <!-- 新增客户弹框 -->
    <el-dialog :title="dialogTitle" :visible.sync="customVisible" width="900px" class="cus_dialog cus_dialog_box">
      <div>
        <el-form :model="customerForm" :rules="rules" ref="customerForm" class="pro-form-inline cus-form-inline" label-width="110px">
          <el-form-item label="客户名称:" prop="strCustName">
            <el-input v-model="customerForm.strCustName" :disabled="isDetail" clearable placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="客户简称:" prop="strCustShortName">
            <el-input v-model="customerForm.strCustShortName" :disabled="isDetail" clearable placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="所属集团名称:" prop="strGroupName">
            <el-input v-model="customerForm.strGroupName" :disabled="isDetail" clearable placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="客户等级:" prop="strCustlevel">
            <el-select v-model="customerForm.strCustlevel" clearable :disabled="isDetail" placeholder="">
              <el-option v-for="(item,index) in levelList" :key="'d'+index" :label="item.StrCustprolevelName" :value="item.Custprolevelid">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="地区:" prop="strRegion">
            <!-- class="infor_field" -->
            <!-- <div
              ref="entRegion"
              :style="{'pointer-events':(isDetail?'none':'all')}"
            >
              <MRegion class="custom-region" :cityGet="true"
                :fullrange="true"
                :selected="selected"
                :search="true"
                @cRegion="changeArea"
              />
            </div>
            <p id="tipLoc" class="error_text" /> -->
            <el-cascader :props="propsAddress" filterable ref="cascaderArr" placeholder="" :disabled="isDetail" v-model="selected" :options="areaList" @change="changeAreaHandle"></el-cascader>
          </el-form-item>
          <el-form-item label="客户类别:" prop="strCustType">
            <el-select v-model="strCustTypeUpdate" filterable clearable placeholder="" :disabled="isDetail" @change="industryChange">
              <el-option v-for="(item,index) in industryList" :key="'e'+index" :label="item.StrCustindustName" :value="{value:item.Custindustid,label:item.StrCustindustName}">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户行业:" prop="strCustindust">
            <el-select v-model="customerForm.strCustindust" clearable filterable placeholder="" :disabled="isDetail" @change="industryNameChange">
              <el-option v-for="(item,index) in industryNameList" :key="'f'+index" :label="item.StrCustindustName" :value="item.Custindustid">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="业务员部门:" prop="strBusidep" class="bus_form">
            <el-cascader ref="cascaderArrOne" v-model="depForm.strBusidepList" :props="props" :disabled="isDetail" clearable filterable :options="departmentList" placeholder="" @change="depChange($event)"></el-cascader>
          </el-form-item>
          <el-form-item label="业务员:" prop="strsaleuserid" class="sale_form">
            <el-select filterable v-model="depForm.strsaleuserid" :disabled="isDetail" clearable placeholder="" @change="salesChange">
              <el-option v-for="(item,index) in salesmanList" :key="'g'+index" :label="item.Username" :value="{value:item.Userid,label:item.Username}">
              </el-option>
            </el-select>
            <!-- <div class="add_btn">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="新增业务员部门和业务员"
                    placement="top"
                  >
                    <el-button
                      type="success"
                      size="mini"
                      @click.native="saveSalesHandle()"
                    >新增</el-button>
                  </el-tooltip>
                </div> -->
          </el-form-item>
        </el-form>
      </div>
      <!-- 已新增业务员列表 -->
      <div class="add_list">
        <div class="add_item" v-for="(item, index) in azList" :key="index">
          <div class="add_item_box">
            <div class="item_box">
              <p class="txt1">业务员部门:</p>
              <div class="txt2">{{item.strorganname}}</div>
            </div>
            <div class="item_box">
              <p class="txt1">业务员:</p>
              <div class="txt2">{{item.username}}</div>
            </div>
          </div>
          <div class="dlt_btn">
            <el-button v-if="!isDetail" type="danger" size="mini" icon="el-icon-delete" @click.native="dltSalesman(index)">删除</el-button>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="customVisible = false" size="small">取消</el-button>
        <el-button :loading="saveLoading" type="primary" :disabled="isDetail" @click="submitForm('customerForm')" size="small">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import xz from "@/common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    name: "serviceCenter",
    data() {
      return {
        // 是否有潜在客户线索权限
        isCrmRole: localStorage.crmRole,
        saveLoading: false,
        // 是否有猎头线索权限
        isHuntCrmRole: localStorage.crmHuntRole,
        loginRoletype: localStorage.loginRoletype,
        dialogTitle: '新增客户',
        // 是否是查看
        isDetail: false,
        customVisible: false,
        // 客户等级
        levelList: [],
        // 业务部门
        departmentList: [],
        // 业务员
        salesmanList: [],
        // 搜索里的业务员列表
        salesmanSearchList: [],
        // 行业类别
        industryList: [],
        // 行业名称
        industryNameList: [],
        // 参数列表参数
        paramQuery: {
          currpage: 1,
          perpage: 100000,
          keyword: '',
          strIsDisable: '', // 传1 禁用的看不到了  不传就全显示
          // JB_base_Busitype 业务类型 JB_base_Custprolevel客户项目等级 JB_base_Legalsub 法务主体
          // JB_base_Jobfunclabel 岗位职能标签 JB_base_Socialsec社保 JB_base_Busisec 商保
          strtableid: 'JB_base_Custprolevel'
        },
        // 列表参数
        listQuery: {
          currpage: 1,
          perpage: 10,
          strorgancode: '',
          roletype: '',
          strCustlevel: '', // 客户等级
          strProvince: '', // 省
          strCity: '', // 市
          custname: '', //客户名称
          username: '', //业务员
          depname: '', //业务部门
          strBusidepList: [], //选中的业务部门
          groupname: '', //所属集团
          strCustType: '', //客户类别
          strCustindust: '' //客户行业
        },
        // 导出参数
        exportQuery: {
          strCustlevel: '', // 客户等级
          strProvince: '', // 省
          strCity: '', // 市
          custname: '', //客户名称
          username: '', //业务员
          depname: '', //业务部门
          groupname: '', //所属集团
          strCustType: '', //客户类别
          strCustindust: '', //客户行业
          strorgancode: '',
          roletype: '',
          perpage: 10000000,
          currpage: 1
        },
        // 按钮权限参数
        butQuery: {
          path: '/customList',
          powerEnName: 'customManage'
        },
        // 业务部门参数
        departQuery: {
          strorgancode: '',
          roletype: ''
        },
        // 业务部门员工参数
        oneDepartQuery: {
          strorgancode: '',
          roletype: ''
        },
        // 部门员工参数
        departMemberQuery: {
          currpage: 1,
          perpage: 10000,
          strWorkState: '',
          keyword: ''
        },
        // 行业列表参数
        industryQuery: {
          currpage: 1,
          perpage: 10000,
          keyword: '',
          strIsDisable: '', // 传1 禁用的看不到了  不传就全显示
          strtabletype: 'parent', // parent child(子级要传strtabletypename)
          strtabletypename: ''
        },
        // 删除客户id
        dltCustid: '',
        tableHeight: 0,
        tableLoading: false,
        rules: {
          strCustName: [{
            required: true,
            message: '请输入客户名称',
            trigger: 'blur'
          }],
          strRegion: {
            required: true,
            message: '请选择地区',
            trigger: 'change'
          }
        },
        tableData: [],
        total: 0,
        // 下拉筛选
        showDropScreen: -1,
        // 新增/编辑客户信息参数
        customerForm: {
          custid: '',
          strCustShortName: '', // 客户简称
          strCustName: '', // 客户名称
          strGroupName: '', // 所属集团
          strCustlevel: '', // 客户等级
          strCustindust: '', // 行业名称 客户行业
          strCustType: '', // 行业分类 客户类别
          strProvince: '', // 省
          strCity: '', // 市
          strRegion: '' // 地区码
        },
        // 新增/编辑业务员/业务部门
        depForm: {
          strorganname: '', //业务部门
          username: '', //业务员
          strBusidepList: [], //选中的业务部门id
          strBusidep: '', //业务部门id
          strsaleuserid: '' //业务员id
        },
        // 新增/编辑的客户类别
        strCustTypeUpdate: '',
        // 已新增业务员列表
        azList: [],
        // 选中的地区值
        selected: [],
        btnLoading: false,
        // 是否禁用
        strIsDisable: '',
        // 区域的数据
        areaCityList: [],
        areaProvinceList: [],
        // 是否是合伙人
        isPartner: '',
        // 省份
        areaList: [],
        // 员工列表参数
        memberComQuery: {
          currpage: 1,
          perpage: 10000000,
          keyword: "",
          strWorkState: "在职",
          strstation: "",
          strorgancode: ""
        },
        // 按钮权限
        permissionLists: [],
        // 自定义 级联选择props
        propsAddress: {
          label: 'Name',
          value: 'Name',
          children: 'children',
          checkStrictly: true
        },
        props: {
          label: 'strorganname',
          value: 'strorgancode',
          children: 'children',
          checkStrictly: true
        }
      }
    },
    created() {
      this.areaCityList = this.$store.state.city
      this.areaProvinceList = this.$store.state.province
      // this.departQuery.roletype = localStorage.loginRoletype
      // this.departQuery.strorgancode = localStorage.gancode
      this.isPartner = localStorage.isPartner
      this.listQuery.roletype = localStorage.loginRoletype
      this.listQuery.strorgancode = localStorage.gancode
      this.getButtonPower()
      this.calHeight()
      // 获取地区
      this.getprovinces('00')
    },
    methods: {
      checkPermission,
      calHeight() {
        this.tableHeight = Number(document.body.clientHeight)
      },
      //选择地址
      changeAreaHandle(val) {
        // console.log('ddd', val)
        if (!this.isNull(val)) {
          // const checkedNode =  this.$refs["cascaderArr"].getCheckedNodes();
          // let labels = checkedNode[0].pathLabels
          if (val.length == 3) {
            this.customerForm.strProvince = val[0]
            this.customerForm.strCity = val[1]
            this.customerForm.strArea = val[2]
          } else if (val.length == 2) {
            this.customerForm.strProvince = val[0]
            this.customerForm.strCity = val[1]
            this.customerForm.strArea = ''
          } else if (val.length == 1) {
            this.customerForm.strProvince = val[0]
            this.customerForm.strCity = ''
            this.customerForm.strArea = ''
          }
        } else {
          this.customerForm.strProvince = ''
          this.customerForm.strCity = ''
        }
        this.customerForm.strRegion = val.toString()
      },
      //获取省市区
      getprovinces() {
        xz.getAreaAll().then(res => {
          // console.log('getprovinces', res)
          // if (res.status == 'ok') {
          this.areaList = res;
          // } else {
          //   this.areaList = [];
          // }
        })
      },
      //根据targetName查询该节点和所有父级节点 回显el-cascader组件的值
      getParentsById(list, targetName) {
        for (let i in list) {
          if (list[i].Name.indexOf(targetName) > -1) {
            //查询到就返回该数组对象
            return [list[i]]
          }
          if (list[i].children) {
            let node = this.getParentsById(list[i].children, targetName)
            if (node !== undefined) {
              //查询到把父节点连起来
              return node.concat(list[i])
            }
          }
        }
      },
      // 搜索
      searchHandle() {
        this.listQuery.currpage = 1
        this.showDropScreen = -1
        this.getList()
      },
      // 获取按钮权限
      getButtonPower() {
        let that = this
        xz.getbtnPowerIdBypage(this.butQuery).then(res => {
          // console.log('按钮',res)
          if (res.status == 'ok') {
            let resmsg = res.msg
            if (!this.isNull(resmsg)) {
              for (let index = 0; index < resmsg.length; index++) {
                let element = resmsg[index];
                this.permissionLists.push(element.Enname);
              }
              if (that.checkPermission(['customList_page_list'], that.permissionLists)) {
                that.getList()
              }
            } else {
              this.permissionLists = []
            }
          } else {
            this.permissionLists = []
          }
        })
      },
      // 是否可导出
      isExports() {
        // console.log('tab',this.isCanHandle)
        return this.isCanHandle || (localStorage.loginRoletype == 'branch') || (localStorage.loginRoletype == 'business') || (this.isPartner == '是')
      },
      // 导出
      exportHandle() {
        this.btnLoading = true
        this.exportQuery.strCustlevel = this.listQuery.strCustlevel
        this.exportQuery.strProvince = this.listQuery.strProvince
        this.exportQuery.strCity = this.listQuery.strCity
        this.exportQuery.custname = this.listQuery.custname
        this.exportQuery.username = this.listQuery.username
        this.exportQuery.depname = this.listQuery.depname
        this.exportQuery.groupname = this.listQuery.groupname
        this.exportQuery.strCustType = this.listQuery.strCustType
        this.exportQuery.strCustindust = this.listQuery.strCustindust
        this.exportQuery.strorgancode = this.listQuery.strorgancode
        this.exportQuery.roletype = this.listQuery.roletype
        xz.getOutCustLists(this.exportQuery).then(res => {
          // console.log('导出', res)
          if (res.status == 'ok') {
            this.$router.push({
              path: "/cusExportList",
              query: {
                showPage: 1,
                isActive: 1,
                custname: res.msg,
                //qStstus=1时查看最后一条导出记录
                qStstus: 1
              }
            })
          } else {
            this.$message({
              message: "导出失败，请稍后再试",
              type: "error"
            })
          }
          this.btnLoading = false
        })
      },
      changeAddress(val) {
        if (val.length == 3) {
          this.listQuery.strProvince = val[0]
          this.listQuery.strCity = val[1]
          this.listQuery.strArea = val[2]
        } else if (val.length == 2) {
          this.listQuery.strProvince = val[0]
          this.listQuery.strCity = val[1]
          this.listQuery.strArea = ''
        } else if (val.length == 1) {
          this.listQuery.strProvince = val[0]
          this.listQuery.strCity = ''
          this.listQuery.strArea = ''
        }
        this.$refs.regAddress._data.dropDownVisible = false;
      },
      // 查看客户
      async dtlHandle(item) {
        this.isDetail = true
        this.dialogTitle = '客户信息'
        this.departQuery.roletype = ''
        this.departQuery.strorgancode = ''
        this.strIsDisable = '1'
        await this.getDepartList()
        this.paramQuery.strIsDisable = '1'
        this.getParamList()
        this.industryQuery.strIsDisable = '1'
        this.industryNameList = []
        this.industryQuery.strtabletype = 'parent'
        this.industryQuery.strtabletypename = ''
        this.getIndustryTypeList()
        this.depForm.strsaleuserid = ''
        this.salesmanList = []
        this.customerForm.custid = item.Custid
        this.getDetailData()
        this.customVisible = true
      },
      // 查找出城市对应码
      getCityCode(data, val) {
        // console.log('lll',data)
        let cityArr = data.filter(element =>
          element.name == val + '市'
        )
        return cityArr
      },
      // 搜索业务部门
      searchDepHandle(val) {
        // console.log('ggg',val)
        this.listQuery.username = ''
        let depLength = Number(val.length)
        if (this.isNull(val)) {
          this.listQuery.depname = ''
        } else {
          this.listQuery.depname = val[depLength - 1]
        }
        // this.oneDepartQuery.strorgancode = val[depLength-1]
        // this.oneDepartQuery.roletype = localStorage.loginRoletype
        if (this.showDropScreen == -1) {
          this.departMemberQuery.strWorkState = '在职'
        } else if (this.showDropScreen == 1) {
          this.departMemberQuery.strWorkState = ''
        }
        // this.getMemberList()
        // this.getList()
      },
      // 搜索行业
      searchCustHandle(val) {
        if (this.showDropScreen == -1) {
          this.industryQuery.strIsDisable = '1'
        } else if (this.showDropScreen == 1) {
          this.industryQuery.strIsDisable = ''
        }
        this.industryQuery.strtabletype = 'child'
        this.industryQuery.strtabletypename = val
        this.getIndustryTypeList()
      },
      // 删除客户
      deleteHandle(item) {
        this.dltCustid = item.Custid
        this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then((res) => {
          xz.delbCust({
            custid: this.dltCustid
          }).then(res => {
            // console.log('删除',res)
            if (res.status == 'ok') {
              this.$message({
                type: 'success',
                message: '删除成功'
              })
              this.getList()
            } else {
              this.$message({
                type: 'error',
                message: res.msg
              })
            }
          }).catch(err => {
            console.log("err", err)
          })
        })
      },
      // 获取客户详情
      getDetailData() {
        this.azList = []
        this.depForm.strBusidepList = []
        xz.getCustDetail(this.customerForm.custid).then(res => {
          if (res.status == 'ok') {
            let jsonRes, jsonMsgma
            if (res.msg) {
              jsonRes = JSON.parse(res.msg)
              this.industryQuery.strtabletype = 'child'
              this.industryQuery.strtabletypename = jsonRes.strCustTypeid
              this.getIndustryTypeList()
              this.strCustTypeUpdate = {
                value: jsonRes.strCustTypeid,
                label: jsonRes.strCustType
              }
              this.customerForm = {
                custid: jsonRes.Custid,
                strCustShortName: jsonRes.StrCustShortName,
                strCustName: jsonRes.StrCustName, // 客户名称
                strGroupName: jsonRes.StrGroupName, // 所属集团
                strCustlevel: jsonRes.StrCustlevel, // 客户等级
                strCustindust: jsonRes.strCustindustid, // 行业名称
                strCustType: jsonRes.strCustTypeid, // 行业分类
                strProvince: jsonRes.StrProvince, // 省
                strCity: jsonRes.StrCity, // 市
                strRegion: jsonRes.StrRegion // 地区码
              }
              // console.log('88',jsonRes)
              // 匹配省市
              let areaVal = '';
              if (!this.isNull(jsonRes.StrProvince)) {
                if (!this.isNull(jsonRes.StrCity)) {
                  areaVal = jsonRes.StrCity
                } else {
                  areaVal = jsonRes.StrProvince
                }
              } else {
                if (!this.isNull(jsonRes.StrCity)) {
                  areaVal = jsonRes.StrCity
                }
              }
              let posArrVal = this.getParentsById(
                this.areaList, areaVal
              );
              // console.log('99',posArrVal)
              if (!this.isNull(posArrVal)) {
                if (posArrVal.length > 1) {
                  this.selected = [posArrVal[1].Name, posArrVal[0].Name]
                } else if (posArrVal.length == 1) {
                  this.selected = [posArrVal[0].Name]
                }
              }
            }
            if (res.msgma) {
              jsonMsgma = JSON.parse(res.msgma)
              // console.log('详情', jsonRes)
              if (jsonMsgma && jsonMsgma.length > 0) {
                for (let i = 0; i < jsonMsgma.length; i++) {
                  const elementMa = jsonMsgma[i]
                  this.azList.push({
                    strorganname: elementMa.Strorganname,
                    strsaleuserid: elementMa.Strsaleuserid,
                    strBusidep: elementMa.StrBusidep,
                    username: elementMa.Username
                  })
                }
              }
            }
          }
        })
      },
      // 新增业务员
      saveSalesHandle() {
        if (this.isNull(this.depForm.strBusidepList)) {
          this.$message({
            message: "请选择业务部门",
            type: "warning"
          })
          return false
        }
        if (this.isNull(this.depForm.username)) {
          this.$message({
            message: "请选择业务员",
            type: "warning"
          })
          return false
        }
        this.azList.push({
          strorganname: this.depForm.strorganname,
          username: this.depForm.username,
          strsaleuserid: this.depForm.strsaleuserid.value,
          strBusidep: this.depForm.strBusidepList[this.depForm.strBusidepList.length - 1]
        })
      },
      depChange(val) {
        // let checkedNode = this.$refs["cascaderArrOne"].getCheckedNodes()
        const checkedNode00 = this.$refs["cascaderArrOne"].panel.getNodeByValue(val);
        // console.log( checkedNode[0].data.label );  //获取当前点击节点的label值
        // console.log( checkedNode[0].pathLabels);  //获取由label组成的数组
        if (!this.isNull(checkedNode00)) {
          // this.depForm.strorganname = checkedNode00[0].pathLabels.join('/')
          if (checkedNode00 && (!this.isNull(checkedNode00.pathLabels))) {
            this.depForm.strorganname = checkedNode00.pathLabels.join('/')
          }
        }
        // console.log('val', val,checkedNode00)
        // let depLength = Number(val.length)
        // this.oneDepartQuery.strorgancode = val[depLength-1]
        // this.oneDepartQuery.roletype = localStorage.loginRoletype
        this.departMemberQuery.strWorkState = '在职'
        // this.getMemberList()
      },
      salesChange(val) {
        this.depForm.username = val.label
        this.saveSalesHandle()
      },
      industryChange(val) {
        this.customerForm.strCustType = val.value
        this.customerForm.strCustindust = ''
        this.industryQuery.strtabletype = 'child'
        this.industryQuery.strtabletypename = val.value
        this.getIndustryTypeList()
      },
      industryNameChange(val) {
        this.customerForm.strCustindust = val
      },
      // 删除业务员
      dltSalesman(index) {
        // console.log('dlt', item)
        // this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
        //   confirmButtonText: '确定',
        //   cancelButtonText: '取消',
        //   type: 'warning'
        // }).then((res) => {
        this.azList.splice(index, 1)
        // })
      },
      // // 选择区域
      // changeArea(datas) {
      //     // console.log('changeArea', datas)
      //     // 区域code
      //     let dataCode = ''
      //     if (datas.area) {
      //         dataCode = datas.area.code
      //     } else if (datas.city) {
      //         dataCode = datas.city.code
      //     } else {
      //         dataCode = datas.province.code
      //     }
      //     this.customerForm.strCity = datas.city.name
      //     this.customerForm.strProvince = datas.province.name
      //     this.customerForm.strRegion = dataCode
      //     if (this.customerForm.strRegion) {
      //         document.getElementById('tipLoc').innerHTML = ''
      //     }
      // },
      // 获取客户列表
      getList() {
        this.tableLoading = true
        xz.getCustLists(this.listQuery).then(res => {
          // console.log('客户', res)
          if (res.status == 'ok') {
            this.tableData = res.msg
            this.total = res.totalcount
          } else {
            this.tableData = []
            this.total = 0
          }
          this.tableLoading = false
        })
      },
      // 获取参数列表(等级)
      getParamList() {
        xz.getParameterList(this.paramQuery).then(res => {
          // console.log('参数', res)
          if (res.status == 'ok') {
            this.levelList = res.msg
          } else {
            this.levelList = []
          }
        })
      },
      // 获取业务部门列表
      getDepartList() {
        xz.getorganstr(this.departQuery.strorgancode, this.departQuery.roletype, {
          strIsDisable: this.strIsDisable
        }).then(res => {
          // console.log('部门', res)
          if (res.status == 'ok') {
            this.departmentList = res.msg.parent[0].children
          } else {
            this.departmentList = []
          }
        })
      },
      // 获取部门员工列表
      getMemberList() {
        xz.getauthUserInfoByorgancode(this.memberComQuery).then(res => {
          // console.log('员工', res)
          if (res.status == 'ok') {
            if (this.showDropScreen == -1) {
              this.salesmanList = res.msg
            } else if (this.showDropScreen == 1) {
              this.salesmanSearchList = res.msg
            }
          } else {
            if (this.showDropScreen == -1) {
              this.salesmanList = []
            } else if (this.showDropScreen == 1) {
              this.salesmanSearchList = []
            }
          }
        })
      },
      // 获取行业列表(类别，名称)
      getIndustryTypeList() {
        xz.getSearchCustindust(this.industryQuery).then(res => {
          // console.log('行业', res)
          if (res.status == 'ok') {
            if (this.industryQuery.strtabletype == 'parent') {
              this.industryList = res.msg
            } else if (this.industryQuery.strtabletype == 'child' && !this.isNull(this.industryQuery.strtabletypename)) {
              this.industryNameList = res.msg
            }
          } else {
            if (this.industryQuery.strtabletype == 'parent') {
              this.industryList = []
            } else if (this.industryQuery.strtabletype == 'child' && !this.isNull(this.industryQuery.strtabletypename)) {
              this.industryNameList = []
            }
          }
        })
      },
      //分页
      changeBPage(val) {
        this.listQuery.currpage = Number(val)
        this.getList()
      },
      handleSizeChange(val) {
        this.listQuery.currpage = 1
        this.listQuery.perpage = Number(val)
        this.getList()
      },
      // 编辑客户
      async editHandle(item) {
        this.isDetail = false
        this.dialogTitle = '编辑客户'
        this.departQuery.roletype = ''
        this.departQuery.strorgancode = ''
        this.departMemberQuery.strWorkState = '在职'
        this.getMemberList()
        this.strIsDisable = '1'
        await this.getDepartList()
        this.paramQuery.strIsDisable = '1'
        this.getParamList()
        this.industryQuery.strIsDisable = '1'
        this.industryNameList = []
        this.industryQuery.strtabletype = 'parent'
        this.industryQuery.strtabletypename = ''
        this.getIndustryTypeList()
        this.depForm.strsaleuserid = ''
        // this.salesmanList = []
        this.customerForm.custid = item.Custid
        this.getDetailData()
        this.customVisible = true
      },
      //新增客户弹窗
      async addHandle() {
        this.isDetail = false
        this.dialogTitle = '新增客户'
        this.industryNameList = []
        // this.salesmanList = []
        this.industryQuery.strtabletype = 'parent'
        this.industryQuery.strtabletypename = ''
        this.departQuery = {
          strorgancode: '',
          roletype: ''
        }
        this.departMemberQuery.strWorkState = '在职'
        this.getMemberList()
        this.strIsDisable = '1'
        await this.getDepartList()
        this.paramQuery.strIsDisable = '1'
        this.getParamList()
        this.depForm = {
          strorganname: '', //业务部门
          username: '', //业务员
          strBusidepList: [],
          strBusidep: '', //业务部门id
          strsaleuserid: '' //业务员id
        }
        this.selected = ''
        this.azList = []
        this.strCustTypeUpdate = ''
        this.customerForm = {
          custid: '',
          strCustShortName: '',
          strCustName: '', // 客户名称
          strGroupName: '', // 所属集团
          strCustlevel: '', // 客户等级
          strCustindust: '', // 行业名称
          strCustType: '', // 行业分类
          strProvince: '', // 省
          strCity: '', // 市
          strRegion: '' // 地区码
        }
        this.industryQuery.strIsDisable = '1'
        this.getIndustryTypeList()
        this.customVisible = true
      },
      //确定新增
      submitForm(formName) {
        let industList = []
        this.azList.forEach(function (item) {
          industList.push({
            strsaleuserid: item.strsaleuserid,
            strBusidep: item.strBusidep
          })
        })
        // console.log('新增', this.customerForm, industList)
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.saveLoading = true
            xz.saveJbCust(this.customerForm, industList).then(res => {
              if (res.status == 'ok') {
                this.customVisible = false
                this.$message({
                  message: "保存成功",
                  type: "success"
                })
                this.getList()
              } else {
                this.$message({
                  message: res.msg,
                  type: "error"
                })
              }
              this.saveLoading = false
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        })
      },
      // 关闭筛选
      closeSearchHandle() {
        this.showDropScreen = -1
        this.memberComQuery.strWorkState = '在职'
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.departQuery.roletype = ''
          this.departQuery.strorgancode = ''
          this.strIsDisable = ''
          // 业务部门
          this.getDepartList()
          // 业务员
          this.memberComQuery.strWorkState = ''
          // this.oneDepartQuery.roletype = localStorage.loginRoletype
          // this.oneDepartQuery.strorgancode = localStorage.gancode
          this.getMemberList()
          this.showDropScreen = 1
          this.paramQuery.strIsDisable = ''
          // 等级
          this.getParamList()
          this.industryQuery.strIsDisable = ''
          // 客户类别
          this.industryQuery.strtabletype = 'parent'
          this.industryQuery.strtabletypename = ''
          this.getIndustryTypeList()
          // // 客户行业
          // this.industryQuery.strtabletype = 'child'
          // this.industryQuery.strtabletypename = ''
          // this.getIndustryTypeList()
        } else if (this.showDropScreen == 1) {
          this.memberComQuery.strWorkState = '在职'
          this.showDropScreen = -1
          this.strIsDisable = '1'
        }
      },
      //判断是否为空(包含0)
      isNull(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0
      },
      //清空
      resetHandle() {
        this.listQuery = this.$options.data.call(this).listQuery
        this.listQuery.strorgancode = localStorage.gancode
        this.listQuery.roletype = localStorage.loginRoletype
        this.salesmanList = []
      }
    }
  };
</script>
<style>
  .p_custom_content .el-tabs {
    background-color: #fff;
    padding: 0 10px;
  }

  .p_custom_content .top-right .el-button+.el-button {
    margin-left: 0;
  }

  .screenInput .el-input .el-input__inner {
    height: 32px;
    line-height: 32px;
  }

  .scr_icon .el-icon-caret-bottom {
    font-size: 18px;
    color: #999;
    cursor: pointer;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  /* .cus_drop_form{
  margin-top: 8px;
} */
  .cus_drop_form .el-form-item {
    margin-bottom: 3px;
  }

  .cus_drop_form .el-input__inner {
    height: 32px;
    line-height: 32px;
  }

  .cus_drop_form .el-select,
  .cus_drop_form .el-form-item__content {
    width: 220px;
  }

  .p_custom_content .el-table .el-table__cell {
    padding: 5px 0 !important;
  }

  .p_custom_content .screenInput .el-select .el-input__inner {
    height: 40px;
    line-height: 40px;
  }

  .cus-form-inline .el-input,
  .cus-form-inline .el-select {
    width: 750px;
  }

  .cus_dialog_box .screenInput .el-select .el-input__inner {
    width: 100%;
    height: 40px;
    line-height: 40px;
  }

  .cus-form-inline .bus_form {
    width: 360px;
    display: inline-block;
  }

  .cus-form-inline .bus_form .el-input {
    width: 250px;
  }

  .cus-form-inline .sale_form .el-input,
  .cus-form-inline .sale_form .el-select {
    width: 240px;
  }

  .cus-form-inline .sale_form {
    width: 450px;
    display: inline-block;
  }

  .cus_dialog_box .pro-form-inline .el-input__inner {
    width: 100%;
  }

  .p_custom_content .screenInputs .screenInput .el-input {
    width: 200px;
  }

  .cus_dialog .p_remark .el-form-item__content {
    width: 710px;
  }

  .sales_dialog .el-form-item__content,
  .sales_dialog .el-select {
    width: 270px;
  }

  .cus_dialog .add_btn i.el-icon-edit {
    color: #409eff;
  }

  .cus_dialog .add_btn i {
    font-size: 20px;
  }

  .cus_dialog .infor_field .el-form-item__content {
    margin-left: 0 !important;
  }

  .cus_dialog .xz_con {
    width: 400px !important;
  }

  .cus_dialog .trigger_select {
    height: 40px !important;
  }

  .cus_dialog .delete_value {
    top: 12px !important;
  }

  .cus_dialog_box .xz_tabs li:nth-child(3) {
    display: none;
  }

  /* .cus_dialog_box .xz_total_domain div:nth-child(3){
  display: none;
} */
</style>
<style scoped>
  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .add_list {
    margin-top: 15px;
  }

  .add_item_box {
    display: flex;
    width: 100%;
  }

  .add_item_box .txt1 {
    width: 75px;
    text-align: right;
    margin-right: 10px;
    color: #606266;
  }

  .add_item_box .txt2 {
    width: 260px;
  }

  .add_list .add_item {
    width: 100%;
    display: flex;
    border-bottom: 1px solid #dfe4ed;
    margin-bottom: 15px;
    box-sizing: border-box;
    padding-bottom: 8px;
  }

  .add_item_box .item_box {
    display: flex;
    width: 45%;
    align-items: center;
    flex-wrap: wrap;
    font-size: 14px;
    margin-right: 8px;
    margin-bottom: 8px;
  }

  .add_btn {
    display: inline-block;
    width: 80px;
    text-align: right;
    margin-left: 10px;
  }

  .p_adds_item {
    display: flex;
    border: 1px dashed #dfe4ed;
    margin-bottom: 8px;
    box-sizing: border-box;
    padding: 5px;
    border-radius: 10px 5px;
  }

  .el-pagination {
    background-color: #fff;
  }

  .reset {
    height: 32px;
    padding: 5px 15px;
    border-radius: 5px;
    color: #B2BCB7;
    background-color: #fff;
    border: 1px solid #fff;
    margin-right: 10px;
  }

  .p-txt {
    color: rgba(0, 0, 0, 0.4);
  }
</style>